import React, { Component } from 'react';
import { Button, IconButton, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import VideoPlayerJW from '../VideoPlayerJW';

const styles = (theme) => ({
  dialogRoot: {},
  dialogTitle: {
    margin: '0',
    padding: '8px 8px 0',
    fontSize: '20px',
    color: theme.palette.primary.main,
  },
  dialogTitleContent: {
    fontWeight: 'bold',
    margin: '0 15px',
    padding: '1em 0',
    borderBottom: `2px solid #d5d5d5`,
  },
  closeBtn: {
    right: '12px',
    top: '4px',
    color: '#5b5b5b',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  dialogContent: {
    marginBottom: '10px',
  },
  dialogActions: {
    borderTop: '1px solid #ebebeb',
    margin: '0 24px',
    textAlign: 'center',
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  contents: {
    padding: theme.spacing(1),
  },
  msgImg: {
    width: '100%',
    height: 'auto',
  },
  tableHead: {
    background: '#f3f3f3',
    width: '160px',
    borderTop: '1px solid #e0e0e0',
    borderLeftWidth: '0px',
    borderRightWidth: '0px',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableContent: {
    borderLeftWidth: '0px',
    borderRightWidth: '0px',
    width: '20%',
    marginRight: '2px',
  },
});

class VideoDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, open, onClose, disableBackdrop, selectedIndex, satellitesData } = this.props;
    const testVideo = 'https://s3.ap-northeast-2.amazonaws.com/hemlibra.web-symposium.co.kr/static/media/test1.8ab528fa.mp4';
    const data = satellitesData[selectedIndex];

    return (
      <React.Fragment>
        <div>
          <Dialog
            fullWidth={true}
            maxWidth={'md'}
            onClose={onClose}
            aria-labelledby="welcome-msg-dialog"
            open={open}
            disableBackdropClick={disableBackdrop}
            disableEscapeKeyDown={disableBackdrop}
            className={classes.dialogRoot}
          >
            <DialogTitle className={classes.dialogTitle}>
              {data ? (
                <div className={classes.dialogTitleContent}>
                  Satellite Session - {data.name}
                  {/* <p style={{ fontSize: '12px', color: '#333' }}>* 화면에 재생버튼을 클릭하여 영상을 실행 시켜주세요.</p> */}
                </div>
              ) : (
                ''
              )}
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={() => {
                  this.props.onClose();
                  this.refs.videoPlayer.updatePlayTime();
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
              <div>
                {data ? (
                  <VideoPlayerJW
                    ref="videoPlayer"
                    onComplete={this.props.onComplete}
                    onPlay={this.props.onPlay}
                    src={data.vod ? data.vod : testVideo}
                    type={'jw'}
                    pgmId={data.id}
                  />
                ) : (
                  ''
                )}
              </div>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button onClick={onClose} className={classes.btnBottom} style={{ color: '#000000', fontSize: '18px', fontWeight: '600' }}>
                닫기
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(VideoDialog);
